export const EMPTY_VALUE_INDICATOR = '—';
export const REQUIRED_INDICATOR = '*';

export const MAX_OPTIONS_BEFORE_SEARCH = 10;

export const API_DATE_FORMAT = 'yyyy/MM/dd';
export const DATE_FORMAT = 'MM/dd/yyyy';
export const DATE_FORMAT_PLACEHOLDER = DATE_FORMAT.toLowerCase();

export const SSN_FIELD_NAME = 'ssn';
export const SIN_FIELD_NAME = 'sin';

export const INFINITE_END_DATE = '2100/01/01';
